import React from "react";
import logo from "./logo2.png";
import "./App.css";

function App() {
  // Initialize Firebase
  const firebase = require("firebase");

  firebase.initializeApp({
    apiKey: "AIzaSyBNU2EDiSdAw2moE5_B-FaL7Kcmtv4InL8",
    authDomain: "recruitflo.firebaseapp.com",
    databaseURL: "https://recruitflo.firebaseio.com",
    projectId: "recruitflo",
    storageBucket: "recruitflo.appspot.com",
    messagingSenderId: "519406139099",
    appId: "1:519406139099:web:6a8353423e8aaf011f7efe",
    measurementId: "G-S7QDCZGKC8",
  });
  firebase.analytics();

  var db = firebase.firestore();

  function signUp() {
    console.log(document.getElementById("email").value);
    var d = new Date();
    console.log(d.toDateString());

    if (document.getElementById("item-1").checked) {
      db.collection("web")
        .doc("coach")
        .collection("list")
        .doc(document.getElementById("email").value)
        .set({
          date: d.toDateString(),
        })
        .then(function () {
          console.log("Document successfully written!");
          alert("Your email has been registered. You'll hear from us soon!");
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
        });
    } else {
      db.collection("web")
        .doc("athlete")
        .collection("list")
        .doc(document.getElementById("email").value)
        .set({
          date: d.toDateString(),
        })
        .then(function () {
          console.log("Document successfully written!");
          alert("Your email has been registered. You'll hear from us soon!");
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
        });
    }
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <img height="50"></img>
        <h1>Sign up to get early access</h1>
        <div className="radioFields">
          <input
            id="item-1"
            class="radio-inline__input"
            type="radio"
            name="accessible-radio"
            value="coach"
            checked="checked"
          />
          <label class="radio-inline__label" for="item-1">
            I am a coach
          </label>
          <input
            id="item-2"
            class="radio-inline__input"
            type="radio"
            name="accessible-radio"
            value="athlete"
          />
          <label class="radio-inline__label" for="item-2">
            I am an athlete
          </label>
        </div>

        <div className="flex-form">
          <input
            type="search"
            id="email"
            placeholder="What's your email??"
          ></input>
          <input type="submit" value="Sign Up" onClick={signUp}></input>
        </div>

        <ul class="policy">
          <li>
            <a href="privacy.html">Privacy policy</a>
          </li>
          <li>
            <div class="spacer"></div>
          </li>
          <li>
            <a href="terms.html">Terms and conditions</a>
          </li>
          <li>
            <div class="spacer"></div>
          </li>
          <li>
            <a href="mailto: team@recruitflo.com">Contact Us</a>
          </li>
        </ul>
      </header>
    </div>
  );
}

export default App;
